import React, { useEffect, useRef, useState } from "react";
import styles from "./SingleProjectPage.module.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ApplyModalSVG from "../../images/SVG/ApplyModalSVG.svg";
import NoOfApplicantsComponent from "../../components/UI/NoOfApplicantsComponent/NoOfApplicantsComponent";
import ReportModal from "../../components/UI/ReportModal/ReportModal";
import CreatedOnComponent from "../../components/UI/CreatedOnComponent/CreatedOnComponent";
import ShareSVG from "../../components/SVGComponents/ShareSVG";
import ThreeDotsSVG from "../../components/SVGComponents/ThreeDotsSVG";
import OpeningsSVG from "../../components/SVGComponents/OpeningsSVG";
import IndustrySVG from "../../components/SVGComponents/IndustrySVG";
import LocationSVG from "../../components/SVGComponents/LocationSVG";
// import DurationSVG from "../../components/SVGComponents/DurationSVG";
import { useDispatch, useSelector } from "react-redux";
import { getProjectbyID } from "../../reducer/projectsSlice";
import Modal from "../../components/Modal/Modal";
import Button from "../../components/UI/Button/Button";
// import cardLogo from "../../images/Card_Logo.png";
import "react-quill-new/dist/quill.snow.css";
import SpinnerLoader from "../../components/UI/SpinnerLoader/SpinnerLoader";
import toast from "../../components/Toast/toast";
import { API } from "../../service/Interceptor";
import { applyProject } from "../../service/apiUrl";
import { serverFiles } from "../../utils/utils";
import FlagSVG from "../../components/SVGComponents/FlagSVG";
import DeleteSVG from "../../components/SVGComponents/DeleteSVG";
import { FaRegEdit } from "react-icons/fa";
import Tooltip from "components/common/Tooltip/Tooltip";
import SingleProjectSkeleton from "./SingleProjectSkeleton";
import DurationSVG from "components/SVGComponents/DurationSVG";
import SandClockSVG from "components/SVGComponents/SandClockSVG";
import DisableSVG from "components/SVGComponents/DisableSVG";
import ProjectDeletionModal from "components/ProjectDeletionModal/ProjectDeletionModal";
import UploadPortfolioModal from "components/UploadPortfolioModal/UploadPortfolioModal";

const SingleProjectPage = ({ setState }) => {
  const { project } = useSelector((state) => state.projects);
  const { userProfile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  const { projectId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const projectURL = `${window.location.origin}/projects/${projectId}`;

  //=================== STATES ====================
  const [reportModal, setReportModal] = useState(false);
  const [threeDotsPopup, setThreeDotsPopup] = useState(false);
  const [appliedModal, setAppliedModal] = useState(false);
  const [applied, setApplied] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [portfolioModal, setPortfolioModal] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const applyBtnRef = useRef(0);
  const delay = 2000; // 1 second delay
  // const [saved, setSaved] = useState(false);

  const createdAt = new Date(project?.createdAt).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  // ====================================================
  //                APPLYING PROJECT
  // ====================================================
  const handleApplyNow = async () => {
    const now = Date.now();

    if (now - applyBtnRef.current >= delay) {
      applyBtnRef.current = now;

      if (userProfile?.isCompleted) {
        try {
          const res = await API.post(`${applyProject}?jobId=${project?.jobId}`);
          if (res?.data?.success) {
            setApplied(true);
            setAppliedModal(true);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        toast.error("Please complete profile section to apply");
      }
    }
  };

  const handleDeleteProject = async (id) => {
    setDeleteModalOpen(true);
    setThreeDotsPopup(false);
    setDeleteId(id);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    dispatch(getProjectbyID(projectId));
  }, [dispatch, projectId]);

  return (
    <>
      {project ? (
        <>
          <section className={styles.single_project_page}>
            {/* TOP TITLE */}
            {/* <section className={styles.single_project_page_heading}>
          <p>{project?.jobTitle}</p>
        </section> */}

            {/* DETAILS SECTION */}
            <section className={styles.single_project_details}>
              {/* DETAILS - TOP CATEGORY SECTION */}
              <section className={styles.single_project_category_days}>
                <div className={styles.single_project_category_left}>
                  <CreatedOnComponent date={createdAt} />

                  {/* <DaysLeftComponent day={2} /> */}

                  {userProfile?.userType !== "CREATOR" ? (
                    <Link to={`applicants`}>
                      <NoOfApplicantsComponent
                        applicants={
                          project?.applicantCount ? project?.applicantCount : 0
                        }
                      />
                    </Link>
                  ) : (
                    // <NoOfApplicantsComponent
                    //   applicants={
                    //     project?.applicantCount ? project?.applicantCount : 0
                    //   }
                    // />

                    <></>
                  )}
                  {/* <SaveSVG
                jobId={project?.jobId}
                saved={saved || project?.isSaved}
                setSaved={setSaved}
                height={24}
                width={24}
              /> */}
                  <ShareSVG
                    // onClick={() => {
                    //   handleShare();
                    // }}
                    text={projectURL}
                    success="Link copied successfully"
                    height={20}
                    width={20}
                  />
                </div>

                {/* RIGHT 3 DOTS */}
                <div className={styles.single_project_category_right}>
                  <Tooltip
                    data={
                      userProfile?.userType === "CREATOR"
                        ? "Report"
                        : "Disable or Edit"
                    }
                    force={true}
                  >
                    <ThreeDotsSVG
                      height={24}
                      width={24}
                      onClick={() => {
                        setThreeDotsPopup((prev) => !prev);
                      }}
                    />
                  </Tooltip>

                  {threeDotsPopup && (
                    <>
                      <div
                        className={styles.dropdown_overlay}
                        onClick={() => setThreeDotsPopup(false)}
                      />

                      <section className={styles.three_dots_popup}>
                        {userProfile?.userType === "BUSINESS" ? (
                          <>
                            <div
                              className={styles.single_btn_section}
                              onClick={() =>
                                handleDeleteProject(project?.jobId)
                              }
                            >
                              <DisableSVG height={18} width={18} />
                              <p className={styles.single_button}>
                                Disable this project
                              </p>
                            </div>

                            <hr className={styles.seperator} />

                            <Link
                              to={`/projects/edit-project/${projectId}`}
                              className="unstyledLink"
                              style={{ paddingLeft: "3px" }}
                            >
                              <div className={styles.single_btn_section}>
                                <FaRegEdit
                                  fontSize={16}
                                  color="black"
                                  fontWeight="thin"
                                />
                                <p className={styles.single_button}>
                                  Edit this project
                                </p>
                              </div>
                            </Link>
                          </>
                        ) : (
                          <div
                            onClick={() => {
                              setReportModal(true);
                              setThreeDotsPopup(false);
                            }}
                            className={styles.single_btn_section}
                          >
                            <FlagSVG height={18} width={18} color="black" />
                            <p className={styles.single_button}>
                              Report this project
                            </p>
                          </div>
                        )}
                      </section>
                    </>
                  )}

                  <ReportModal
                    type="Project"
                    id={project?.jobId}
                    reportModal={reportModal}
                    setReportModal={setReportModal}
                  />
                </div>
              </section>

              {/* DETAILS - TITLE, IMAGE SECTION */}
              <section className={styles.single_project_title_section}>
                <div>
                  <p className={styles.single_project_title}>
                    {project?.jobTitle}
                  </p>
                  <Link
                    to={`/user-profile/${project?.company?.userAliasId}`}
                    className={styles.single_project_company_name}
                  >
                    {project?.company?.name}
                  </Link>
                </div>
                <div className={styles.single_project_logo}>
                  {/* <img src={serverFiles(project?.company?.logo)} alt="" /> */}
                </div>
              </section>

              {/* DETAILS - BUDGET LOCATION SECTION */}
              <section className={styles.details_budget_location}>
                <div className={styles.project_openings}>
                  <OpeningsSVG height={28} width={28} />
                  <div>
                    <p className={styles.project_openings_label}>Openings</p>
                    <p className={styles.project_openings_number}>
                      {project?.noOfOpenings}
                    </p>
                  </div>
                </div>
                {/* <div className={styles.project_budget}>
              <BudgetSVG height={28} width={28} />
              <div>
                <p className={styles.project_budget_label}>Budget</p>
                <p className={styles.project_budget_number}>
                  {formatToINRCurrency(project?.projectBudget)}
                </p>
              </div>
            </div> */}

                <div className={styles.project_industry}>
                  <IndustrySVG height={28} width={28} />
                  <div>
                    <p className={styles.project_industry_label}>Work Title</p>
                    <p className={styles.project_industry_details}>
                      {project?.industry?.length ? (
                        <Tooltip
                          data={project?.industry?.join(", ")}
                          force={true}
                        >
                          {project?.industry?.length && project?.industry[0]}
                        </Tooltip>
                      ) : (
                        "None"
                      )}
                    </p>
                  </div>
                </div>
                <div className={styles.project_location}>
                  <LocationSVG height={28} width={28} />

                  <div>
                    <p className={styles.project_location_label}>Location</p>
                    <p className={styles.project_location_details}>
                      {project?.city?.name}, {project?.state?.name}
                    </p>
                  </div>
                </div>

                <div className={styles.project_duration}>
                  <SandClockSVG height={28} width={28} />

                  <div>
                    <p className={styles.project_duration_label}>
                      Project Duration
                    </p>
                    <p className={styles.project_duration_details}>
                      {project?.projectDuration
                        ? `${project?.projectDuration} day${
                            project?.projectDuration > 1 ? "s" : ""
                          }`
                        : "0 days"}
                    </p>
                  </div>
                </div>
              </section>

              {/* DETAILS - MEDIA SECTION */}
              {/* {project?.media.length > 0 ? (
            <section className={styles.media_section}>
              <p className={styles.media_section_title}>Media</p>

              <div className={styles.media_images}>
                {project?.media?.map((item, index) => (
                  <img src={item} alt="" key={index}></img>
                  // <p>{item}</p>
                ))}
              </div>
            </section>
          ) : (
            <></>
          )} */}

              {/* DETAILS - ABOUT THE PROJECT */}
              <section className={styles.details_about_this_project}>
                <p className={styles.details_about_this_project_heading}>
                  About this project
                </p>

                {/* {parse(project?.description)} */}
                {/* {project?.description} */}
                <div
                  className="ql-editor"
                  style={{
                    lineHeight: 2.42,
                  }}
                  dangerouslySetInnerHTML={{ __html: project?.description }}
                />
                {/* <div></div> */}
              </section>

              {/* DETAILS - SKILLS REQUIRED */}
              <section className={styles.details_skills_section}>
                <p className={styles.details_skills_heading}>Skills required</p>

                <div className={styles.details_skills}>
                  {project?.skillsRequired?.map((skill, i) => (
                    <p key={i} className={styles.details_skills_skill}>
                      {skill}
                    </p>
                  ))}
                </div>
              </section>

              {/* DETAILS - APPLY BUTTON */}
              {userProfile?.userType === "CREATOR" ? (
                <section className={styles.details_apply_button}>
                  {!project?.isApplied ? (
                    <button
                      className={styles.apply_button}
                      onClick={() => setPortfolioModal(true)}
                    >
                      Apply Now
                    </button>
                  ) : (
                    <>
                      <button className={styles.applied_button}>Applied</button>
                    </>
                  )}
                </section>
              ) : (
                <></>
              )}
            </section>
          </section>

          <Modal
            modalOpen={shareModal}
            onClose={() => setShareModal((prev) => !prev)}
          >
            <h2>Share</h2>
          </Modal>
        </>
      ) : (
        <>
          <SingleProjectSkeleton />
        </>
      )}

      {/* APPLIED MODAL */}
      {appliedModal && (
        <Modal
          onClose={() => setAppliedModal((prev) => !prev)}
          modalOpen={appliedModal}
        >
          <div className={styles.apply_modal_main}>
            <div className={styles.apply_modal_image}>
              <img src={ApplyModalSVG} alt="" />
            </div>

            <div className={styles.apply_modal_details}>
              <p className={styles.apply_modal_title}>Application Submitted</p>
              <p className={styles.apply_modal_description}>
                You can monitor the progress in My Applications
              </p>

              <div className={styles.apply_modal_buttons}>
                <Link to="/projects" className={`unstyledLink`}>
                  <Button variant={"outlined"}>Continue Applying</Button>
                </Link>

                <Link className="unstyledLink" to="/my-applications">
                  <Button
                    className={styles.apply_modal_applications_btn}
                    variant={"filled"}
                  >
                    My Applications
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* DELETE MODAL */}
      {deleteModalOpen && (
        <ProjectDeletionModal
          id={deleteId}
          projectDeleted={deleteModalOpen}
          setProjectDeleted={setDeleteModalOpen}
        />
      )}

      {/* PORTOFLIO MODAL */}
      <Modal
        background="#fff"
        onClose={() => setPortfolioModal((prev) => !prev)}
        modalOpen={portfolioModal}
      >
        <UploadPortfolioModal
          portfolioModal={portfolioModal}
          setPortfolioModal={setPortfolioModal}
          userProfile={userProfile}
          isOpen={portfolioModal}
          onClose={() => setPortfolioModal((prev) => !prev)}
          // applyBtn={handleApplyNow}
          projectId={projectId}
          applied={applied}
          setApplied={setApplied}
          setAppliedModal={setAppliedModal}
        />
      </Modal>
    </>
  );
};

export default SingleProjectPage;
